'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceGpsNotFixed = function DeviceGpsNotFixed(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
  );
};
DeviceGpsNotFixed = (0, _pure2.default)(DeviceGpsNotFixed);
DeviceGpsNotFixed.displayName = 'DeviceGpsNotFixed';
DeviceGpsNotFixed.muiName = 'SvgIcon';

exports.default = DeviceGpsNotFixed;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/device/gps-not-fixed.js
// module id = 2166
// module chunks = 0